module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/i18next-localstorage-cache/index.js
// module id = 215
// module chunks = 0 1 2 3